import React from "react";
import Nft2 from "assets/img/nfts/Nft2.png";
import Nft1 from "assets/img/nfts/Nft1.png";
import Nft3 from "assets/img/nfts/Nft3.png";
import Nft4 from "assets/img/nfts/Nft4.png";
import Nft5 from "assets/img/nfts/Nft5.png";
import Nft6 from "assets/img/nfts/Nft6.png";

import { FaDollarSign, FaEthereum } from "react-icons/fa";
import Card from "components/card";

const HistoryCard = () => {
  const HistoryData = [
    {
      image: Nft1,
      title: "Invoice: Jan, 17 2023",
      owner: "INV-#024215",
      price: 1200,
      time: "30s",
    },
    {
      image: Nft2,
      title: "Invoice: Feb, 17 2023",
      owner: "INV-#024216",
      price: 2200,
      time: "50m",
    },
    {
      image: Nft2,
      title: "Invoice: Mar, 10 2023",
      owner: "INV-#024217",
      price: 200,
      time: "50m",
    },
    {
      image: Nft2,
      title: "Invoice: Mar, 25 2023",
      owner: "INV-#024219",
      price: 3500,
      time: "50m",
    },
    {
      image: Nft2,
      title: "Invoice: Apr, 10 2023",
      owner: "INV-#024222",
      price: 2200,
      time: "50m",
    },
    {
      image: Nft2,
      title: "Invoice: Aug, 15 2023",
      owner: "INV-#024233",
      price: 200,
      time: "50m",
    },
    {
      image: Nft2,
      title: "Invoice: Sep, 15 2023",
      owner: "INV-#024232",
      price: 2200,
      time: "50m",
    },
    {
      image: Nft2,
      title: "Invoice: Oct, 29 2023",
      owner: "INV-#024244",
      price: 5000,
      time: "50m",
    },

  ];

  return (
    <Card extra={"!z-5 overflow-hidden"}>
      {/* HistoryCard Header */}
      <div className="flex items-center justify-between rounded-t-3xl p-3">
        <div className="text-lg font-bold text-navy-700 dark:text-white">
        Recent invoices
        </div>
        <button className="linear rounded-[20px] bg-lightPrimary px-4 py-2 text-base font-medium text-brand-500 transition duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20">
          See all invoices
        </button>
      </div>

      {/* History CardData */}

      {HistoryData.map((data, index) => (
        <div className="flex h-full w-full items-start justify-between bg-white px-3 py-[20px] hover:shadow-2xl dark:!bg-navy-800 dark:shadow-none dark:hover:!bg-navy-700">
          <div className="flex items-center gap-3">
            {/* <div className="flex h-16 w-16 items-center justify-center">
              <img
                className="h-full w-full rounded-xl"
                src={data.image}
                alt=""
              />
            </div> */}
            <div className="flex flex-col">
              <h5 className="text-base font-bold text-navy-700 dark:text-white">
                {" "}
                {data.title}
              </h5>
              <p className="mt-1 text-sm font-normal text-gray-600">
                {" "}
                {data.owner}{" "}
              </p>
            </div>
          </div>

          <div className="mt-1 flex items-center justify-center text-navy-700 dark:text-white">
            <div>
              <FaDollarSign />
            </div>
            <div className="ml-1 flex items-center text-sm font-bold text-navy-700 dark:text-white">
              <p> {} </p>
              {data.price} 
            </div>
            <div className="ml-2 flex items-center text-sm font-normal text-gray-600 dark:text-white">

              <a href="/admin/invoices/view">
              <button>View PDF</button>
              </a>
              {/* <p>{data.time}</p>
              <p className="ml-1">ago</p> */}
            </div>
          </div>
        </div>
      ))}
    </Card>
  );
};

export default HistoryCard;
